import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ratingReported: {
    defaultMessage: 'Vielen Dank für deine Einschätzung.',
    id: 'rating.rating-reported',
  },
  ratingReportError: {
    defaultMessage: 'Feedback konnte nicht abgegeben werden.',
    id: 'rating.rating-report-error',
  },
  reportRating: {
    defaultMessage: 'Optionen zu dieser Bewertung',
    id: 'rating.report-rating',
  },
});
